import { render } from "./FormerProducer.vue?vue&type=template&id=2ec16d51"
import script from "./FormerProducer.vue?vue&type=script&lang=js"
export * from "./FormerProducer.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__